export default __webpack_public_path__ + "pgnv-assets/ef9075e0fcbc53458532839cd29a5ff3.png";